<template>
	<div>
		<nav-bar-home></nav-bar-home>
		
		<!-- Loader Container -->
		<app-loader v-show="isLoading" />

		<!-- Main Content -->
		<component v-show="!isLoading" :is="currentComponent" :layout="layout" />
		
		<footer-section></footer-section>
	</div>
</template>

<script>
import NavBarHome from "@/components/NavBarHome.vue"
import FooterSection from "@/components/FooterSection.vue"
import AppLoader from "@/components/AppLoader.vue"
// Preload the components
import PageLayoutOne from "@/components/layouts/PageLayoutOne.vue";
import PageLayoutTwo from "@/components/layouts/PageLayoutTwo.vue";
import PageLayoutNine from "@/components/layouts/PageLayoutNine.vue";
import PageLayoutSix from "@/components/layouts/PageLayoutSix.vue";
import PageLayoutSeven from "@/components/layouts/PageLayoutSeven.vue";
import PageLayoutEight from "@/components/layouts/PageLayoutEight.vue";

import AboutUs from "@/views/AboutUs.vue";
import { mapActions } from 'vuex';

export default {
	components: {
		NavBarHome,
		FooterSection,
		AppLoader,
		PageLayoutOne,
		PageLayoutTwo,
		PageLayoutNine,
		PageLayoutSix,
		PageLayoutSeven,
		PageLayoutEight,
		AboutUs,
	},
	data() {
		return {
			layout: null,
			currentComponent: null,
			isLoading: true,
		};
	},
	methods: {
		...mapActions(['getPageLayoutData']),
		getComponentBySlug(slug) {
			if (slug.startsWith("page-layout-one")) {
				return "PageLayoutOne";
			} else if (slug.startsWith("page-layout-two")) {
				return "PageLayoutTwo";
			} else if (slug.startsWith("page-layout-nine")) {
				return "PageLayoutNine";
			} else if (slug.startsWith("page-layout-six")) {
				return "PageLayoutSix";
			} else if (slug.startsWith("page-layout-seven")) {
				return "PageLayoutSeven";
			} else if (slug.startsWith("page-layout-eight")) {
				return "PageLayoutEight";
			} else if (slug.startsWith("about-us")) {
				return "AboutUs";
			} else {
				return "PageLayoutOne";
			}
		},
	},
	async created() {
		const slug = this.$route.params.slug;
		this.currentComponent = this.getComponentBySlug(slug);
		
		const result = await this.getPageLayoutData(slug);
		this.layout = Array.isArray(result) ? result[0] : result;
		this.isLoading = false;
	}
}
</script>

<style>
.innovation-section {
	padding: 120px 0;
}

.innovation-section .block-title-w {
	margin-bottom: 15px;
}
.innovation-section .block-title-w h2{
	margin-bottom: 40px;
}

.design-content-block {
	gap: 77px;
	padding: 0;
}

.design-content-block .left-image {
	max-width: 600px;
	width: 100%;
}

.right-content {
	width: 100%;
}

.design-content-block img {
	width: 100%;
	height: auto;
	border-radius: 16px;
	aspect-ratio: 1/0.98;
}

.design-title {
	font-weight: 500;
	font-size: 32px;
	line-height: 52px;
	vertical-align: middle;
	margin-bottom: 8px;
	color: #1A1A1A;
}

.design-content-block p {
	font-weight: 400;
	font-size: 20px;
	line-height: 30.4px;
	color: #1A1A1A;

}

.vestiGO-info-section {
	padding: 0;
	gap: 50px;
	align-items: flex-start;
}

.info-card {
	border-radius: 16px;
	padding: 0px 55px;
	height: 100%;
	max-width: 600px;
	width: 100%;
}

.left-card .info-title {
	font-family: Roboto, sans-serif;
	font-weight: 500;
	font-size: 32px;
	line-height: 35px;
	margin-bottom: 15px;
	color: #1A1A1A;
}

.left-card .info-subtitle {
	font-family: Roboto, sans-serif;
	font-weight: 400;
	font-size: 20px;
	line-height: 30px;
	margin-bottom: 10px;
	color: #1A1A1A;
}

.left-card .info-description {
	font-weight: 400;
	font-size: 20px;
	line-height: 30px;
	color: #1A1A1A;
}

.right-card .quote-text {
	font-weight: 400;
	font-size: 32px;
	line-height: 42px;
	text-align: center;
	vertical-align: middle;
	margin: 0;
	color: #1A1A1A;
}

.image-grid-section {
	padding: 120px 0;
}

.single-img {
	max-width: 100%;
	width: 100%;
}

.single-img img {
	width: 100%;
	height: 100%;
	aspect-ratio: 1/0.73;
	object-fit: cover;
	border-radius: 16px;
}
</style>